import { Box, styled, useMediaQuery, useTheme } from '@mui/material'
import { consistencyIcons } from './const'
import { Container, ContentWrapper, StatusLabel } from './DeliveryStatus.styled'
import { TConsistency } from '../../../types/models/Consistency'

const IconContainer = styled(Box)<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${({ color }) => color || 'inherit'};
`

export const DeliveryStatus = (consistency: TConsistency) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <Container>
      <ContentWrapper>
        <IconContainer color={consistency?.color?.hex_code}>
          {consistencyIcons[consistency?.icon_name || 'default']?.icon}
        </IconContainer>
        <StatusLabel fontSize={isSmallScreen ? '16px' : '22px'}>
          {consistency?.label || consistency?.name}
        </StatusLabel>
      </ContentWrapper>
    </Container>
  )
}
